import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConnectivityTimerService {
  private inactivityTimer: number | null = null;
  private inactivityTime = 0;
  private inactivityTimeSubject = new BehaviorSubject<number>(0);

  public get inactivityTime$(): Observable<number> {
    return this.inactivityTimeSubject.asObservable();
  }

  public startTimer(): void {
    if (this.inactivityTimer) {
      return;
    }
    this.inactivityTimer = window.setInterval(() => this.tick(), 1000);
  }

  public stopTimer(): void {
    const hasTimer = !!this.inactivityTimer;
    if (hasTimer) {
      clearInterval(this.inactivityTimer!);
      this.inactivityTimer = null;
    }
    if (!hasTimer && this.inactivityTime === 0) {
      return;
    }
    this.inactivityTime = 0;
    this.inactivityTimeSubject.next(0);
  }

  public resetTimer(): void {
    this.inactivityTime = 0;
    this.inactivityTimeSubject.next(0);
  }

  private tick(): void {
    this.inactivityTimeSubject.next(++this.inactivityTime);
  }
}
